export default {
  computed: {
    is_admin() {
      return this.$store.state.auth.user.admin
    }
  }
}
